import { setDiscoveryRuleDeleteRow } from '@process-advisor/process-miner/api/methods/model/discoveryRuleDeleteRow';
import { setCommentDeleteRow } from '@process-advisor/process-miner/api/methods/model/commentDeleteRow';
import { deleteDiscoveryRule } from '@process-advisor/process-miner/api/methods/model/deleteDiscoveryRule';
import { deleteComment } from '@process-advisor/process-miner/api/methods/model/deleteComment';
import { importTransformation } from '@process-advisor/process-miner/api/methods/model/importTransformation';
import { deleteTransformationRow } from '@process-advisor/process-miner/api/methods/model/deleteTransformationRow';
import { resetTransformation } from '@process-advisor/process-miner/api/methods/model/resetTransformation';
import { saveTransformation } from '@process-advisor/process-miner/api/methods/model/saveTransformation';
import { setDeleteTransformationRow } from '@process-advisor/process-miner/api/methods/model/setDeleteTransformationRow';
import { saveFilterSettings } from '@process-advisor/process-miner/api/methods/model/saveFilterSettings';
import { processFilters } from '@process-advisor/process-miner/api/methods/model/processFilters';
import { resetIcons } from '@process-advisor/process-miner/api/methods/model/resetIcons'
import { setDetailSource } from '@process-advisor/process-miner/api/methods/model/setDetailSource';
import { processDiscoveryRule } from '@process-advisor/process-miner/api/methods/model/processDiscoveryRule'
import { processDiscoveryRuleDataGrid } from '@process-advisor/process-miner/api/methods/model/processDiscoveryRuleDataGrid'
import { processDiscoveryRuleUpdateDiagram} from '@process-advisor/process-miner/api/methods/model/processDiscoveryRuleUpdateDiagram'
import { deleteFinding } from '@process-advisor/process-miner/api/methods/model/deleteFinding'
import { setFindingDeleteRow } from '@process-advisor/process-miner/api/methods/model/findingDeleteRow'
import { processFinding } from '@process-advisor/process-miner/api/methods/model/processFinding'
import { processFindingDataGrid } from '@process-advisor/process-miner/api/methods/model/processFindingDataGrid'
import { processFindingUpdateDiagram } from '@process-advisor/process-miner/api/methods/model/processFindingUpdateDiagram'

export const modelMethods = {
    setDiscoveryRuleDeleteRow,
    deleteDiscoveryRule,
    importTransformation,
    deleteComment,
    setCommentDeleteRow,
    deleteTransformationRow,
    setDeleteTransformationRow,
    resetTransformation,
    saveFilterSettings,
    processFilters,
    resetIcons,
    saveTransformation,
    setDetailSource,
    processDiscoveryRule,
    processDiscoveryRuleDataGrid,
    processDiscoveryRuleUpdateDiagram,
    deleteFinding,
    setFindingDeleteRow,
    processFinding,
    processFindingDataGrid,
    processFindingUpdateDiagram
};
